import { formatCurrency, NULL_DISPLAY } from "@platform/design-system";

import { CellPairDisplay } from "./CellPairDisplay";
import { shouldStackPair } from "./shouldStackPair";

import type { CellPair } from "@platform/formatting-utils/financials";
import type { FinancialsRow } from "../types";
import type { ICellRendererParams } from "ag-grid-community";

export const DollarSavingsCellRenderer = (
  params: ICellRendererParams<FinancialsRow, CellPair | null>,
): React.JSX.Element => {
  const pair = params.value ?? null;
  if (pair === null) return <>{NULL_DISPLAY}</>;

  return (
    <CellPairDisplay
      pair={pair}
      formatLeg={formatCurrency}
      stacked={shouldStackPair(pair, formatCurrency, params)}
    />
  );
};
